import React, { useState } from 'react';
import { makerVariant } from '../variant-resolver.tsx';
const faqs = [{
  question: 'What does it mean for my store to be “agent-ready”?',
  answer: 'AI agents like ChatGPT and Perplexity are already browsing, comparing, and buying on behalf of shoppers. Agent-ready means your store speaks their language — structured data, semantic search, MCP Server access, and clean API endpoints so agents can read, understand, and act on your catalogue accurately.'
}, {
  question: 'Do I need to rebuild my store from scratch?',
  answer: 'No. GreatStore works with what you already have. You can import your existing Figma designs, connect your product catalogue, and go live without starting over. The AI layers on top of your current store, not instead of it.'
}, {
  question: 'What are MCP Apps and why do they matter?',
  answer: 'MCP Apps are native experiences that run directly inside AI environments like ChatGPT — without sending shoppers to an external website. Instead of losing them to a redirect, your store lives inside the conversation itself. It\'s a completely new shopping surface most stores aren\'t on yet.'
}, {
  question: 'Will my store look like every other AI shopping experience?',
  answer: 'No. GreatStore gives you a full visual editor, AI builder, and brand style guides so every detail — fonts, colors, layouts, media — is yours. The AI does the work, but the store looks like your brand, not a template.'
}, {
  question: 'Who is GreatStore built for?',
  answer: 'GreatStore is built for brands that take commerce seriously — stores with real catalogues, real customers, and a need to stay ahead as shopping behavior shifts toward AI-driven discovery. If you care about conversion, discoverability, and being ready for what\'s next, GreatStore is for you.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const [isMobile, setIsMobile] = React.useState(() => window.innerWidth < 768);
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  const toggle = (i: number) => {
    setOpenIndex(prev => prev === i ? -1 : i);
  };
  return <section data-name="FAQ" data-nav-theme="dark" style={{
    backgroundColor: '#091717',
    width: '100%'
  }}>
      <div className="section-content faq-container" style={{
      maxWidth: '1360px',
      margin: '0 auto',
      width: '100%',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '100px',
      paddingBottom: '100px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '48px'
    }}>
        {/* Left column — title */}
        <div data-name="FAQ Title" className="faq-title-col" style={{
        width: '35%',
        flexShrink: 0
      }}>
          <h2 className="section-title" style={{
          fontSize: 'clamp(52px, 7vw, 92px)',
          lineHeight: 1.05,
          color: '#FCFAF6',
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          margin: 0
        }}>
            FAQs
          </h2>
        </div>

        {/* Right column — accordion */}
        <div data-name="FAQ Accordion" className="faq-accordion" style={{
        flex: 1,
        minHeight: '420px'
      }}>
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          const isLast = i === faqs.length - 1;
          return <div key={i} data-name={`FAQ Item ${i + 1}`} style={{
            borderTop: 'none',
            borderBottom: 'none'
          }}>
                {/* Question row */}
                <button onClick={() => toggle(i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 0',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              gap: '24px'
            }} data-tracking-id="btn-548b4eb968f3130c">
                  <span className="faq-question" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '24px',
                color: '#FCFAF6',
                lineHeight: 1.3
              }}>
                    {faq.question}
                  </span>
                  <span style={{
                display: 'inline-block',
                fontSize: '14px',
                lineHeight: 1,
                color: '#FCFAF6',
                flexShrink: 0,
                minWidth: '14px',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease'
              }} aria-hidden="true">▾</span>
                </button>

                {/* Answer */}
                <div id={`faq-panel-${i}`} role="region" style={{
              maxHeight: isOpen ? '500px' : '0',
              overflow: 'hidden',
              opacity: isOpen ? 1 : 0,
              transition: 'max-height 0.4s ease, opacity 0.4s ease'
            }}>
                  <p className="faq-answer" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 400,
                fontSize: isMobile ? '16px' : '20px',
                color: '#FCFAF6',
                lineHeight: 1.6,
                margin: 0,
                paddingBottom: '28px'
              }}>
                    {faq.answer}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
};